import React, { useMemo } from 'react';

import {
  Container,
} from './VirtualFieldList.styles';
import { Anything } from 'src/types';
import { formatPace, getDurationInSeconds, getLengthInMeters } from 'src/utils';
import { StyledTypeIcon } from '../Something/SomethingDetails';

type VirtualFieldListProps = {
  anythings: {
    [index: string]: Array<Anything>
  }
};

function VirtualFieldList({
  anythings,
  ...rest
}: VirtualFieldListProps) {
  const speeds: Array<number> = useMemo(() => {
    const lengthValue = anythings.LENGTH?.[0]
    const durationValue = anythings.TIME?.[0]
    if (lengthValue && durationValue) {
      const length = getLengthInMeters(`${lengthValue.value1}${lengthValue.value2}`)
      const duration = getDurationInSeconds(`${durationValue.value1}${durationValue.value2}`)
      const speed_ms = length / duration // meters per second
      const pace = (duration / 60) / (length / 1000) // minutes per kilometer
      return [speed_ms, pace]
    }
    return []
  }, [anythings.LENGTH, anythings.TIME]);

  if (!speeds || speeds.length == 0) {
    return null
  }

  return (
    <Container {...rest}>
      <b>Beräknade fält&nbsp;<StyledTypeIcon type="VIRTUAL" /></b><br />
      {formatPace(speeds[1])}<br />
      {speeds[1].toFixed(2)} min/km<br />
      {speeds[0].toFixed(2)} m/s<br />
      {(speeds[0] * 3.6).toFixed(2)} km/h<br />
    </Container>
  );
}

export default VirtualFieldList;
